import { Box, styled } from '@mui/material';

const StyledNotificationFooter = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.hairline.main}`,
  flex: 'none',
  padding: theme.spacing(1),
  textAlign: 'center'
}));

export default StyledNotificationFooter;
